module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec-8-c3a9501c74199eb44e382c1ff8babaf3.jpg";